import React from 'react';
export const FAQ = () => {
  return <section className="w-full bg-gray-50 py-10 px-4" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-97">
          Vos Questions, Nos Réponses
        </h2>
        <div className="space-y-6" data-id="element-98">
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-99">
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-100">
              "J'ai déjà essayé des appareils TENS, ça ne marche pas"
            </h3>
            <p className="text-gray-700" data-id="element-101">
              <span className="font-bold" data-id="element-102">Réponse :</span> Les TENS de pharmacie
              n'utilisent qu'UNE seule technologie à faible intensité. KinéPulse
              combine QUATRE thérapies synergiques à intensité médicale. C'est
              comme comparer une ampoule de 40W à un système d'éclairage
              professionnel.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-103">
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-104">
              "C'est trop beau pour être vrai"
            </h3>
            <p className="text-gray-700 italic" data-id="element-105">
              "Il y a 10 ans, on disait la même chose des greffes de cellules
              souches. Aujourd'hui, c'est routine. La médecine évolue plus vite
              que nos préjugés." - Dr. Martineau
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-106">
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-107">
              "Mon diabétologue ne m'en a jamais parlé"
            </h3>
            <p className="text-gray-700" data-id="element-108">
              <span className="font-bold" data-id="element-109">Réponse :</span> Les médecins
              prescrivent ce qu'ils connaissent : des médicaments. KinéPulse
              n'est pas un médicament, donc il ne figure pas dans leurs
              protocoles. Beaucoup découvrent son efficacité grâce à leurs
              patients qui l'essaient.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-110">
            <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-111">
              "Et si ça ne marche pas pour moi ?"
            </h3>
            <p className="text-gray-700" data-id="element-112">
              <span className="font-bold" data-id="element-113">Réponse :</span> C'est justement
              pourquoi nous offrons 30 jours d'essai complet. Si vous ne
              ressentez pas au moins une amélioration, nous vous remboursons
              intégralement. Vous ne risquez que vos pieds... en ne l'essayant
              PAS.
            </p>
          </div>
        </div>
      </div>
    </section>;
};